// Categorias sugeridas para os itens do "O que há de novo"
export const WHATS_NEW_CATEGORIES = [
  'Melhoria',
  'Correção',
  'Novo recurso',
  'Mudança de processo',
  'Atualização de layout',
  'Integração',
  'Indicadores',
  'Contratos',
  'Financeiro',
  'Recrutamento',
  'Meu Futuro App',
]

// Status do comunicado
export const WHATS_NEW_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
}

export const WHATS_NEW_STATUS_OPTIONS = [
  { value: WHATS_NEW_STATUS.DRAFT, name: 'Rascunho' },
  { value: WHATS_NEW_STATUS.PUBLISHED, name: 'Publicado' },
  { value: WHATS_NEW_STATUS.ARCHIVED, name: 'Arquivado' },
]

export const WHATS_NEW_STATUS_LABELS = {
  [WHATS_NEW_STATUS.DRAFT]: 'Rascunho',
  [WHATS_NEW_STATUS.PUBLISHED]: 'Publicado',
  [WHATS_NEW_STATUS.ARCHIVED]: 'Arquivado',
}

export const WHATS_NEW_STATUS_VARIANTS = {
  [WHATS_NEW_STATUS.DRAFT]: 'secondary',
  [WHATS_NEW_STATUS.PUBLISHED]: 'success',
  [WHATS_NEW_STATUS.ARCHIVED]: 'warning',
}
